import React from 'react';
import { styled } from '../../../../components-core/packages/components-core/dist/theme-provider';

//LAYOUT
import { 
    Container, 
    ContainerWrap, 
    ContainerHorizontalAlignment,
    ContainerVerticalAlignment,
    ContainerGutter
} from '../../../../components-core/packages/components-core/dist/container';
import { Breakpoints } from '../../../../components-core/packages/components-core/dist/helpers';
import { BreakpointWrapper } from '../../../../components-core/packages/components-core/dist/breakpoint-wrapper';

//STYLE
import { Text, TextAppearance, TextColor } from '../../../../components-core/packages/components-core/dist/text';

//ICONS CORE
import { FindCar } from '../../../../components-core/packages/icons-core/dist/FindCar';


class TitleSection extends React.Component {

    render() {
        return (
            <Container wrap={ContainerWrap.always} gutter={ContainerGutter.dynamic0050}>
                <Container 
                    wrap={ContainerWrap.never} 
                    horizontalAlign={ContainerHorizontalAlignment.spaceBetween}
                    verticalAlign={ContainerVerticalAlignment.center}
                >
                    <Text appearance={TextAppearance.headline0350} bold>
                        Aracınıza en uygun
                        <Text bold={false}> ekonomi paketlerini görüntüleyin</Text>
                    </Text>
                    <BreakpointWrapper min={Breakpoints.b1280}>
                        <FindCar variant={'large'}/>
                    </BreakpointWrapper>
                </Container>
                <Text appearance={TextAppearance.copy0200} color={TextColor.secondary}  >
                    Sorgulamak için<Text> araç plakanızı </Text> girmeniz yeterlidir.
                </Text>
            </Container>
        )
    }
}

export default TitleSection;